import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/brand/gtr-evolution-logo-color-on-dark.svg'
import _imports_1 from '../assets/img/brand/gtr-evolution-isotipo-color.svg'


const _hoisted_1 = {
  id: "main-sidebar",
  class: "navbar navbar-dark navbar-expand-md flex-md-column pb-md-0"
}
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "navbar-brand pt-3 pb-2 pt-md-2 pb-md-0 mx-0" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-end" }
const _hoisted_6 = { class: "main-menu-container d-md-flex flex-grow-1" }
const _hoisted_7 = {
  id: "main-menu",
  class: "navbar-collapse collapse collapse-horizontal flex-md-column flex-md-fill",
  ref: "menuDiv"
}
const _hoisted_8 = { class: "navbar-nav mb-2 py-2 mb-md-0 flex-column flex-md-fill" }
const _hoisted_9 = { class: "nav-link-text" }
const _hoisted_10 = { class: "w-75 sidebar-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_powered_by = _resolveComponent("powered-by")!

  return (_openBlock(), _createElementBlock("div", {
    id: "main-nav",
    class: _normalizeClass(["d-md-flex", { 'sidebar-collapsed': _ctx.uiPreferencesStore.sidebarCollapsed }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn sidebar-collapse-toggle d-none d-md-flex",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uiPreferencesStore.toggleSidebarCollapsed())),
        "aria-label": 
          _ctx.uiPreferencesStore.sidebarCollapsed
            ? 'Expandir menú'
            : 'Colapsar menú'
        ,
        title: 
          _ctx.uiPreferencesStore.sidebarCollapsed
            ? 'Expandir menú'
            : 'Colapsar menú'
        
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa-sharp fa-solid fa-fw", 
            _ctx.uiPreferencesStore.sidebarCollapsed
              ? 'fa-chevron-right'
              : 'fa-chevron-left'
          ])
        }, null, 2)
      ], 8, _hoisted_2),
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"sidebar-bg\" aria-hidden=\"true\" data-v-77e65d29><svg class=\"sidebar-hex sidebar-hex-amber\" xmlns=\"http://www.w3.org/2000/svg\" data-v-77e65d29><defs data-v-77e65d29><pattern id=\"hex-sidebar-pattern-amber\" x=\"0\" y=\"0\" width=\"34.641\" height=\"60\" patternUnits=\"userSpaceOnUse\" data-v-77e65d29><polygon points=\"17.32,0 34.641,10 34.641,30 17.32,40 0,30 0,10\" fill=\"none\" stroke=\"rgba(232, 182, 71, 0.22)\" stroke-width=\"1.4\" vector-effect=\"non-scaling-stroke\" data-v-77e65d29></polygon><line x1=\"17.32\" y1=\"40\" x2=\"17.32\" y2=\"60\" stroke=\"rgba(232, 182, 71, 0.22)\" stroke-width=\"1.4\" vector-effect=\"non-scaling-stroke\" data-v-77e65d29></line></pattern></defs><rect width=\"100%\" height=\"100%\" fill=\"url(#hex-sidebar-pattern-amber)\" data-v-77e65d29></rect></svg><svg class=\"sidebar-hex sidebar-hex-red\" xmlns=\"http://www.w3.org/2000/svg\" data-v-77e65d29><defs data-v-77e65d29><pattern id=\"hex-sidebar-pattern-red\" x=\"0\" y=\"0\" width=\"34.641\" height=\"60\" patternUnits=\"userSpaceOnUse\" data-v-77e65d29><polygon points=\"17.32,0 34.641,10 34.641,30 17.32,40 0,30 0,10\" fill=\"none\" stroke=\"rgba(229, 20, 43, 0.42)\" stroke-width=\"1.4\" vector-effect=\"non-scaling-stroke\" data-v-77e65d29></polygon><line x1=\"17.32\" y1=\"40\" x2=\"17.32\" y2=\"60\" stroke=\"rgba(229, 20, 43, 0.42)\" stroke-width=\"1.4\" vector-effect=\"non-scaling-stroke\" data-v-77e65d29></line></pattern></defs><rect width=\"100%\" height=\"100%\" fill=\"url(#hex-sidebar-pattern-red)\" data-v-77e65d29></rect></svg><span class=\"orb orb-primary\" data-v-77e65d29></span><span class=\"orb orb-counter\" data-v-77e65d29></span><div class=\"sidebar-depth\" data-v-77e65d29></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "--mx-4 mx-md-auto"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  class: "sidebar-logo-full",
                  src: _imports_0,
                  alt: "GTR Evolution"
                }, null, -1),
                _createElementVNode("img", {
                  class: "sidebar-logo-isotipo",
                  src: _imports_1,
                  alt: "GTR Evolution"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "mx-2 sidebar-divider d-none d-md-block" }, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          class: "btn btn-outline-light menu-toggler collapsed d-md-none",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#main-menu",
          "aria-controls": "navbarTogglerDemo01",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, [
          _createElementVNode("span", { class: "menu-toggler-icon" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem.Key,
                class: _normalizeClass('text-nowrap nav-item'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideMenu()))
              }, [
                _createVNode(_component_router_link, {
                  to: menuItem.Route,
                  class: "nav-link ps-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sharpIcon(menuItem.Icon) + ' me-2')
                    }, null, 2),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(menuItem.MenuLabel || menuItem.Label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "sidebar-divider d-none d-md-block mb-1" }, null, -1)),
        _createVNode(_component_powered_by, { class: "text-light small text-center d-none d-md-block" })
      ])
    ])
  ], 2))
}